<template>
	<el-dialog :visible.sync="showimportwin" :title="dialogtitle" width="500px" :append-to-body="true"  :close-on-click-modal="false">
		<div class="divimport">
			<div style="text-align: center;">
				<el-form :inline="true" class="demo-form-inline" v-if="type==''">
					<el-form-item label="导入账号">
						<el-autocomplete
							ref="u_account"
							:trigger-on-focus="false"
							v-model="user.u_account"
							:fetch-suggestions="searchvip"
							placeholder="请输入账号\姓名"
							@select="checkuser"
							value-key="u_account"
							size="small"
							@change="val =>changeuser(val)"
						>
							<template slot-scope="{ item }">
								<div> {{ item.u_name }} ({{ item.u_account }} )</div>
							</template>
						</el-autocomplete>
					</el-form-item>
					<el-form-item><span style="color:#ee8b1a">可选择用户账号进行代导入</span></el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-form :inline="true" class="demo-form-inline">
					<el-form-item label="选择文件">
						<el-upload
							name="fileupload"
							drag
							:action="fileurl"
							:multiple="false"
							:limit="1"
							accept=".xlsx,.xls"
							auto-upload
							:on-success="UploadSuccess"
							:on-error="UploadError"
							:on-change="UploadChange"
							:show-file-list="false"
							ref="upload"
							:file-list="filelist"
							:before-upload="UploadBefore"
						>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">
								将文件拖到此处，或
								<em>点击上传</em>
								<br />
								( 支持 .xlsx .xls 文件 )
								<br /><br />
							</div>
						</el-upload>
						<div style="width:100%;text-align:center;">{{ filename }}</div>
					</el-form-item>
					</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<div style="text-align:center;width:100%;padding-top:10px">
					<el-button size="mini" type="success" @click.native="sure">确定</el-button>
					<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="showimportwin = false">关闭</el-button>
				</div>
			</span>
		</div>
		
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			showimportwin: false,
			fileurl: '',
			dialogtitle: '',
			mode: '', //功能名称
			downpath: '',
			filename: '',
			divclass: 'divimport',
			uploadfileurl: '',
			tid: '',
			filelist: [],
			isreload:false,
			checktype:'',
			user:{
				u_userid:localStorage.getItem('userid'),
				u_account:localStorage.getItem('u_account')
			},
			type:''
		};
	},
	methods: {
		init(param) {
			//debugger
			this.filelist = [];
			this.filename = '';
			this.uploadfileurl = '';
			this.tid = '';

			this.showimportwin = true;
			this.mode = param.mode;
			if(param.type!=undefined)
				this.type=param.type;
			this.dialogtitle = param.dialogtitle;
			if(param.isreload!=undefined)
				this.isreload=param.isreload;
			this.fileurl =
				this.$apiprototype.ApiServer +
				'/Order/checkexcelfile?domain=' +
				this.$apiprototype.WebServer+ '&mode=&userid='+this.user.u_userid+'&modetype='+this.type;
			//console.log('上传地址', this.fileurl);
		},
		UploadSuccess(res, file, fileList) {
			this.$tool.loadingclose();
			if (res.state == '1') {
				this.uploadfileurl = res.fileurl;
				this.filename = res.filename;
				this.tid = res.tid;
				this.checktype=res.checktype;
			} else {
				this.filename = '';
				this.$tool.message(res.message, 0);
			}
			this.$refs.upload.clearFiles();
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			if (fileList.length > 0) this.$tool.loading('正在检测文件', this.divclass);
		},
		UploadBefore(file){
		if(this.user.u_userid=='')
			{
				this.$tool.loadingclose();
				if(this.$refs.upload!=undefined){
					this.$refs.upload.clearFiles();
					this.$refs.upload.abort();
				}
				else{
					if(this.$refs.upload.length>0)
					{
						this.$refs.upload[0].clearFiles();
						this.$refs.upload[0].abort();
					}
				}
				this.$tool.message('请选择导入账号', 0);
			}
		},
		//检测信息
		checkdata(inportinfo) {
			var error = '';
			inportinfo.fileurl = this.uploadfileurl;
			inportinfo.tid = this.tid;
			inportinfo.u_userid =this.user.u_userid;
			inportinfo.u_account=this.user.u_account;
			inportinfo.handleuaccount=localStorage.getItem('u_account');
			if (inportinfo.fileurl == '' || inportinfo.fileurl == undefined) {
				error = '请上传文件';
				this.$tool.message(error, 0);
				return '';
			} else {
				return inportinfo;
			}
		},
		sure() {
			var that = this;
			var inportinfo = new Object();
			inportinfo = this.checkdata(inportinfo);
			if (inportinfo != '') {
				// console.log('inportinfo', escape(JSON.stringify(inportinfo)));
				// return false;
				this.$tool.loading('正在导入', this.divclass);
				this.$apipost.post.SaveInport({ inportinfo: JSON.stringify(inportinfo) }).then(res => {
					//console.log('res', res);
					if (res != '') {
						if (res.state == '1') {
							that.handlecomplete(res.batch);
						} else {
							this.$tool.loadingclose();
							if (res.localfilename != undefined) {
								if(res.localfilename!=""){
									this.$tool.downfile(that, res.localfilename, res.tempbatch);
								}
							}
							if (res.state == '2') {
								if (res.message != undefined) this.$tool.message(res.message, 1);
								setTimeout(function() {
									that.showimportwin = false;
								}, 1500);
							}
							else{
								this.$tool.message(res.message, 0);
							}
						}
					} else {
						this.$tool.loadingclose();
						this.$tool.message('导入异常，请重试', 0);
					}
				}).catch(e=>{
					this.$tool.loadingclose();
					this.$tool.message('导入异常，请重试', 0);
				});
			}
		},
		handlecomplete(batch){
			var that=this;
			if(this.checktype=='3'){
				this.$apipost.post.ImportOrderPush({ p_batch: batch }).then(res => {
					this.$tool.loadingclose();
					if(res.state=='1'){
						this.$tool.message('导入成功', 1);
						that.showimportwin = false;
					}else{
						this.$tool.loadingclose();
						this.$tool.message(res.message, 0);
						if (res.localfilename != undefined) {
							if(res.localfilename!='')
								this.$tool.downfile(that, res.localfilename);
							that.showimportwin = true;
						}
					}
				});
			}
			else{
				this.$tool.message('导入成功', 1);
				this.$tool.loadingclose();
				that.showimportwin = false;
				if(that.isreload)
					that.$parent.refreshgrid(true);
			}
		},
		GetSearchObj() {
			var searchinfo = {
				searchbox: this.user.u_account
			};
			return searchinfo;
		},
		searchvip(val, cb) {
			var that = this;
			setTimeout(function() {
				if (val != '') {
					//获取会员卡列表
					var paraminfo = {
						mode: '会员列表',
						tab: '',
						search: that.GetSearchObj(),
						pageindex: 0,
						pagesize: 20,
						sort: '',
						iscount: 0,
						showcol: ''
					};
					that.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
						cb(res.data);
					});
				}else{
					this.user={
						u_userid:'',
						u_account:''
					}
				}
			}, 300);
		},
		checkuser(val) {
			this.user={
				u_userid:val.u_userid,
				u_account:val.u_account
			}
			this.fileurl =
				this.$apiprototype.ApiServer +
				'/Order/checkexcelfile?domain=' +
				this.$apiprototype.WebServer+ '&mode=&userid='+this.user.u_userid;
		},
		changeuser(val){
			this.user={
				u_userid:''
			}
		}
	}
};
</script>
